(ns teamoesterreich.admin-mode.data.backend

  (:require [clojure.walk]
            [teamoesterreich.setup :as setup]
            [teamoesterreich.util.log :as log]
            [teamoesterreich.view-state :as store]))



(def setup setup/config)

(def BASE_URL (:backend-server-url setup))
(def WS_URL (:websocket-server-url setup))

(def LR_FEED_FAQ (:lr-feed-faq setup))
(def LR_FEED_NEWS (:lr-feed-news setup))

(defn get-auth []
  (let [auth-state @store/auth-state]
    (log/debug "get-auth for " (and auth-state (.. auth-state -profile -sub)))
    auth-state))

